module.exports = __webpack_public_path__ + "static/media/pdp_paperTripleThick.91b7e8f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/papertypes/pdp_paperTripleThick.jpg
// module id = 1439
// module chunks = 71